import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import data from '../../../../assets/mock-data/demo-chart-data.json';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  fetch(): Observable<ChartData[]> {
    return of(this.array);
  }

  array: ChartData[] = data as ChartData[];
}

export interface ChartData {
  type: string;
  month1: number;
  month2: number;
  month3: number;
  month4: number;
  month5: number;
  month6: number;
  total: number;
}
